<div
	#container
	(clickOutside)="afterClickOutside()"
	[class.epic-datepicker--visible]="isVisible"
	[style.left]="left"
	[style.top]="top"
	[style.bottom]="bottom"
	class="epic-datepicker">
	<div class="epic-datepicker__indicator-container">
		<button class="epic-datepicker__button" (click)="previous(); $event.stopPropagation()">
			<epic-icon name="arrow-left" />
		</button>
		@if (mode === 'years') {
			<span>{{ middleYear - 7 }} - {{ middleYear + 7 }}</span>
		} @else if (mode === 'months') {
			<span (click)="setMode('years'); $event.stopPropagation()">{{ year }}</span>
		} @else {
			<span (click)="setMode('years'); $event.stopPropagation()">{{ month | titlecase }} {{ year }}</span>
		}
		<button class="epic-datepicker__button" (click)="next(); $event.stopPropagation()">
			<epic-icon name="arrow-right" />
		</button>
	</div>

	@if (mode === 'years') {
		<div class="epic-datepicker__years">
			@for (_ of Array(7); track $index) {
				<button
					type="button"
					class="epic-datepicker__element epic-datepicker__element--years"
					(click)="selectYear(middleYear - (7 - $index)); $event.stopPropagation()">
					{{ middleYear - (7 - $index) }}
				</button>
			}

			<button
				type="button"
				class="epic-datepicker__element"
				(click)="selectYear(middleYear); $event.stopPropagation()">
				{{ middleYear }}
			</button>

			@for (_ of Array(7); track $index) {
				<button
					type="button"
					class="epic-datepicker__element"
					(click)="selectYear(middleYear + ($index + 1)); $event.stopPropagation()">
					{{ middleYear + ($index + 1) }}
				</button>
			}
		</div>
	} @else if (mode === 'months') {
		<div class="epic-datepicker__months">
			@for (month of months; track month) {
				<button
					type="button"
					class="epic-datepicker__element epic-datepicker__element--months"
					(click)="selectMonth($index); $event.stopPropagation()">
					{{ month | titlecase }}
				</button>
			}
		</div>
	} @else {
		<div class="epic-datepicker__days">
			@for (day of daysOfTheWeek; track day) {
				<div class="epic-datepicker__day">{{ day }}</div>
			}

			@for (_ of Array(offset); track $index) {
				<div></div>
			}

			@for (_ of Array(numberOfDaysInAMonth); track $index) {
				<button
					type="button"
					class="epic-datepicker__element"
					[class.epic-datepicker__element--current]="isCurrentDate($index + 1)"
					[class.epic-datepicker__element--active]="isSelectedDate($index + 1)"
					(click)="selectDate($index + 1); $event.stopPropagation()"
					[disabled]="isDayLessThanMin($index + 1) || isDayGreaterThanMax($index + 1)">
					{{ $index + 1 }}
				</button>
			}
		</div>
	}
</div>
